import gaEventTracker, { events } from "util/gaEventTracker";

export const types = {
    SET_INTERNAL_TRANSFER_DATA: "transfers/SET_INTERNAL_TRANSFER_DATA",
    REQUEST_INTERNAL_TRANSFER_DATA: "transfers/REQUEST_INTERNAL_TRANSFER_DATA",
    SUCEESS_INTERNAL_TRANSFER_DATA: "transfers/SUCEESS_INTERNAL_TRANSFER_DATA",
    TRANSFER_TICKET_SUCCESS: "transfers/TRANSFER_TICKET_SUCCESS",
    CLEAN_TRANSFER_TICKET: "transfers/CLEAN_TRANSFER_TICKET",
    SET_OTHER_TRANSFER_DATA: "transfers/SET_OTHER_TRANSFER_DATA",
    REQUEST_OTHER_TRANSFER_DATA: "transfers/REQUEST_OTHER_TRANSFER_DATA",
    REQUEST_ACCOUNT_INFO_BY_CBU: "transfers/REQUEST_ACCOUNT_INFO_BY_CBU",
    SET_PROGRAM_TRASFER_DATA: "transfers/SET_PROGRAM_TRASFER_DATA",
    SET_PROGRAM_TRASFER_DATA_OTHER: "transfers/SET_PROGRAM_TRASFER_DATA_OTHER",
    CLEAN_PROGRAM_DATA: "transfers/CLEAN_PROGRAM_DATA",
    CANCEL_TRANSFER_REQUEST: "transfers/CANCEL_TRANSFER_REQUEST",

    GENERATE_TRANSFER_MEP_VALIDATION_REQUEST: "transfers/GENERATE_TRANSFER_MEP_VALIDATION_REQUEST",
    GENERATE_TRANSFER_MEP_VALIDATION_SUCCESS: "transfers/GENERATE_TRANSFER_MEP_VALIDATION_SUCCESS",
    GENERATE_TRANSFER_MEP_VALIDATION_FAILURE: "transfers/GENERATE_TRANSFER_MEP_VALIDATION_FAILURE",

    GENERATE_TRANSFER_MEP_REQUEST: "transfers/GENERATE_TRANSFER_MEP_REQUEST",
    GENERATE_TRANSFER_MEP_SUCCESS: "transfers/GENERATE_TRANSFER_MEP_SUCCESS",
    GENERATE_TRANSFER_MEP_FAILURE: "transfers/GENERATE_TRANSFER_MEP_FAILURE",

    GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_REQUEST: "transfers/GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_REQUEST",
    GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_SUCCESS: "transfers/GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_SUCCESS",
    GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_FAILURE: "transfers/GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_FAILURE",
};

export const INITIAL_STATE = {
    internalTransferData: {},
    fetching: false,
    transferTicket: { status: "", idTransaction: "" },
    otherTransferData: {},
    programTrasferData: null,
    programTrasferDataOther: null,
    allowedMep: true,
    allowedTransfer: true,
    closingHourStart: null,
    closingHourEnd: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        internalTransferData,
        transferTicket,
        otherTransferData,
        programTrasferData,
        programTrasferDataOther,
        allowedMep,
    } = action;
    switch (action.type) {
        case types.SET_INTERNAL_TRANSFER_DATA:
            return {
                ...state,
                internalTransferData,
            };
        case types.TRANSFER_TICKET_SUCCESS:
            return {
                ...state,
                transferTicket,
            };
        case types.SET_OTHER_TRANSFER_DATA:
            return {
                ...state,
                otherTransferData,
            };
        case types.CLEAN_TRANSFER_TICKET:
            return {
                ...state,
                transferTicket: { status: "", idTransaction: "" },
            };
        case types.SET_PROGRAM_TRASFER_DATA:
            return {
                ...state,
                programTrasferData,
            };
        case types.SET_PROGRAM_TRASFER_DATA_OTHER:
            return {
                ...state,
                programTrasferDataOther,
            };
        case types.CLEAN_PROGRAM_DATA:
            return {
                ...state,
                programTrasferData: null,
                programTrasferDataOther: null,
            };
        case types.GENERATE_TRANSFER_MEP_VALIDATION_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GENERATE_TRANSFER_MEP_VALIDATION_SUCCESS:
            return {
                ...state,
                fetching: false,
                allowedMep: true,
            };
        case types.GENERATE_TRANSFER_MEP_VALIDATION_FAILURE:
            return {
                ...state,
                fetching: false,
                allowedMep: allowedMep,
            };
        case types.GENERATE_TRANSFER_MEP_REQUEST:
            return {
                ...state,
                fetching: true,
            };

        case types.GENERATE_TRANSFER_MEP_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.GENERATE_TRANSFER_MEP_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.GENERATE_TRANSFER_HOUR_VALIDATION_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_SUCCESS:
            return {
                ...state,
                fetching: false,
                allowedTransfer: true,
            };
        case types.GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_FAILURE:
            return {
                ...state,
                fetching: false,
                allowedTransfer: true,
            };
        default:
            return state;
    }
};

export const actions = {
    setInternalTransferData: (internalTransferData) => ({
        type: types.SET_INTERNAL_TRANSFER_DATA,
        internalTransferData,
    }),
    sendInternalTransfer: (internalTransferData, formikBag, credentialType) => {
        gaEventTracker.triggerEvent(events.trans_mis_cuentas_enviar());
        gaEventTracker.triggerEvent(events.newTransfer());
        return {
            type: types.REQUEST_INTERNAL_TRANSFER_DATA,
            internalTransferData,
            formikBag,
            credentialType,
        };
    },
    setOtherTransferData: (otherTransferData) => ({
        type: types.SET_OTHER_TRANSFER_DATA,
        otherTransferData,
    }),

    sendOtherTransfer: (otherTransferData, formikBag, credentialType) => {
        gaEventTracker.triggerEvent(events.trans_pagos_enviar({ tipoPago: "other", cantOrdenesPago: null }));
        gaEventTracker.triggerEvent(events.newTransfer());
        return {
            type: types.REQUEST_OTHER_TRANSFER_DATA,
            otherTransferData,
            formikBag,
            credentialType,
        };
    },
    requestAccountInfoByCbu: ({ creditCbu, formikBag }) => ({
        type: types.REQUEST_ACCOUNT_INFO_BY_CBU,
        creditCbu,
        formikBag,
    }),
    cleanTransferTicket: () => ({
        type: types.CLEAN_TRANSFER_TICKET,
    }),
    setProgramTrasferData: (programTrasferData) => ({
        type: types.SET_PROGRAM_TRASFER_DATA,
        programTrasferData,
    }),
    setProgramTrasferDataOther: (programTrasferDataOther) => ({
        type: types.SET_PROGRAM_TRASFER_DATA_OTHER,
        programTrasferDataOther,
    }),
    cleanProgramData: () => ({
        type: types.CLEAN_PROGRAM_DATA,
    }),
    cancelTransfer: (summary, formikBag, credentialType) => ({
        type: types.CANCEL_TRANSFER_REQUEST,
        summary,
        formikBag,
        credentialType,
    }),

    generateMepValidation: () => ({
        type: types.GENERATE_TRANSFER_MEP_VALIDATION_REQUEST,
    }),

    generateMepTrasnsfer: (otherTransferData, formikBag, credentialType) => ({
        type: types.GENERATE_TRANSFER_MEP_REQUEST,
        otherTransferData,
        formikBag,
        credentialType,
    }),

    generateClosingHourTransferValidation: () => ({
        type: types.GENERATE_TRANSFER_CLOSINGHOUR_VALIDATION_REQUEST,
    }),
};
